/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-03-04 10:23:58
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-13 14:18:26
 */
import Vue from 'vue'
const callList = {
    state: {
        listId: '',
    },
    mutations: {
        //设置名单ID
        SET_LIST_ID: (state, id) => {
            state.listId = id
            Vue.ls.set('listId', id)
        },
    },
    actions: {

    }
}

export default callList


// WEBPACK FOOTER //
// ./src/store/modules/call-list.js